import React, { useContext, useRef } from 'react'
import EledoArticleView from './EledoArticleView'
import { PlatformContext } from 'PlatformContext'
import useArticleHistory from 'hooks/useArticleHistory'

function EledoArticlesPage() {
  const platform = useContext(PlatformContext)
  const history = useArticleHistory("/" + platform.documentationPaths.root)
  const scrollableRef = useRef<HTMLDivElement>(null)
  
  return (
    <div ref={scrollableRef} style={{padding: '20px 30px', height: '100vh', overflow: 'auto'}}>
      <EledoArticleView root={platform.documentationPaths.root} path={"/" + platform.documentationPaths.root} history={history} scrollableRef={scrollableRef}/>
    </div>
  )
}

export default EledoArticlesPage